import React from 'react'
import {observer} from "mobx-react"
import {FaChartBar, FaTractor, FaUser} from 'react-icons/fa'

import {store} from '../../stores/store'
import '../AepPopup/aep-popup.css'
import IndicatorsPool from '../../js/IndicatorsPool'
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore'
import BadgesPool from '../../js/BadgesPool'


function BottomLeftUI() {

  const reportOpened = PopupStore.isOpened(POPUPS_IDS.REPORT)
  const myfarmOpened = PopupStore.isOpened(POPUPS_IDS.MYFARM)
  const profileOpened = PopupStore.isOpened(POPUPS_IDS.PROFILE)
  let zIndex = reportOpened || myfarmOpened || profileOpened ? 1 : 0

  return (
    <div className="bottom-left-ui" style={{zIndex}}>
      <div className="ui-button ui-button-left ui-button-bottom">

        {/* <span className="label profile">

          {IndicatorsPool.getIndicatorValue("indT47")} {store.t('points')}

          {BadgesPool.notif && <div className="notif">!</div>}
          <span
          className={"icon" + (profileOpened ? " selected" : "")}
          onClick={()=> PopupStore.toggle(POPUPS_IDS.PROFILE)}>
            <FaUser />
          </span>
        </span> */}


        <div className="separator" />
        <span
        className={"icon" + (reportOpened ? " selected" : "")}
        onClick={()=> PopupStore.toggle(POPUPS_IDS.REPORT)}>
          <FaChartBar />
        </span>


        <span
        className={"icon" + (myfarmOpened ? " selected" : "")}
        onClick={() => PopupStore.toggle(POPUPS_IDS.MYFARM)}>
          <FaTractor />
        </span>
      </div>
    </div>


  )
}

export default observer(BottomLeftUI)
